import { combineReducers } from 'redux';
import { connectRouter, RouterState } from 'connected-react-router';
import { History } from 'history';
import { reducersRaw as decisionReducers } from '../../decision/state/reducers';
import { reducersRaw as folderReducers } from '../../folders/state/reducers';
import { reducersRaw as searchReducers } from '../../search/state/reducers';
import { reducersRaw as userReducer } from '../../user/state/reducers';
import { reducersRaw as userWatchersReducer } from '../../watchers/state/reducers';
import { reducersRaw as notificationsReducer } from '../../navigation/notification/state/reducers';
import {
  hiddenFeaturesReducer as hiddenFeatures,
  defaultState as hiddenFeatureDefaultState,
} from '../../hidden-features/reducers/hiddenFeatures';

import { DecisionReducerType } from '../../decision/state/decisionState.types';
import { UserReducerType } from '../../user/state/userState.types';
import {
  FoldersReducerType,
  LatestUpdatedReducerType,
  DecisionsReducerType,
} from '../../folders/state/foldersState.types';
import { ResultsType } from '../../search/state/reducers/results.types';
import { SearchMenuType } from '../../search/state/reducers/searchMenu.types';
import {
  UserWatchersReducerType,
  WatchersReducerType,
  WatcherExistsType,
} from '../../watchers/state/watchersState.types';
import { QueryParamsType } from '../../search/state/reducers/queryParams.types';
import { NotificationReducerType } from '../../navigation/notification/state/notificationsState.types';
import { AggregationsType } from '../../search/search.types';
import { AggregationsTreeType } from '../../search/state/reducers/aggregationsTree';
import { SearchType } from '../../search/state/reducers/search.types';

export type StateType = {
  decision: DecisionReducerType;
  user: UserReducerType;
  folders: FoldersReducerType;
  latestUpdated: LatestUpdatedReducerType;
  decisions: DecisionsReducerType;
  results: ResultsType;
  userWatchers: UserWatchersReducerType;
  watchers: WatchersReducerType;
  queryParams: QueryParamsType;
  aggregations: AggregationsType;
  searchMenu: SearchMenuType;
  search: SearchType;
  notifications: NotificationReducerType;
  watcherExists: WatcherExistsType;
  aggregationsTree: AggregationsTreeType;
  hiddenFeatures: typeof hiddenFeatureDefaultState;
  router: RouterState;
};

const reducers = (history: History<any>) =>
  combineReducers({
    ...searchReducers,
    ...folderReducers,
    ...decisionReducers,
    ...userReducer,
    ...userWatchersReducer,
    ...notificationsReducer,
    hiddenFeatures,
    router: connectRouter(history),
  });

export default reducers;
